import {
	LoadingSkeleton,
	LoadingSkeletonItem,
} from 'components/LoadingSkeleton';

interface Props {
	stockType: 'store' | 'web';
}

/** Loading skeleton for detailed stock balance */
export default function LoadingStockBalanceListRowSkeleton({
	stockType,
}: Props) {
	return (
		<div className="p-4">
			<LoadingSkeleton>
				{/* Icon and title. */}
				<div className="mb-4 flex items-center">
					<LoadingSkeletonItem
						height="1.5rem"
						width="1.5rem"
						className="mr-2"
					/>
					<LoadingSkeletonItem height="text" width="6rem" />
				</div>
				<div className="pl-8">
					{/* Stock amount. */}
					<LoadingSkeletonItem width="7rem" height="text" />
					{/* Store selector button.
					Skipping selected store info since it loads async and would cause an
					additional layout shift from the skeleton before everything is loaded. */}
					{stockType === 'store' && (
						<LoadingSkeletonItem
							width="5.5rem"
							height="2rem"
							className="mt-4"
						/>
					)}
				</div>
			</LoadingSkeleton>
		</div>
	);
}
LoadingStockBalanceListRowSkeleton.displayName =
	'LoadingStockBalanceListRowSkeleton';
